export const COLORS = ["#039be5", "#7986cb", "#33b679", "#8e24aa", "#e67c73", "#f6c026", "#f5511d", "#036be5", "#616161", "#3f51b5", "#0b8043", "#d60000"];